// extracted by mini-css-extract-plugin
export default {"toolCards":"CourseManagementPage_toolCards__nVTXC","gearGif":"CourseManagementPage_gearGif__8OEWM"};